<template>
  <section v-if="listLocalDesigners && listLocalDesigners.length" class="pt-24">
    <h2 class="heading-4-bd mb-8">Discover our Local Designers' Offerings</h2>
    <p class="mb-20">
      Our Travel Designers are local experts in their destinations and have a deep understanding of the local culture and history. They are passionate about
      travel and helping people create unforgettable experiences.
    </p>
    <div class="scroll-wrapper">
      <div class="scroll-container">
        <div class="scroll-items-section" style="width: 1230px">
          <div class="flex pb-24">
            <LocalDesignerCard v-for="item in listLocalDesigners" :key="item.id" :data="item" style="width: 20%; min-width: 230px" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { isEmpty } from '~/helper';
import LocalDesignerCard from './LocalDesignerCard.vue';
import { useTripPlanStore } from '~/store/pinia/tripPlan'

const tripPlanStore = useTripPlanStore()

const dataTrip = computed(() => tripPlanStore.dataTrip)
const listLocalDesigners = computed(() => {
  if (isEmpty(dataTrip.value)) return []
  return dataTrip.value.suggest_local_designer || []
})

</script>

<style lang="scss" scoped>
@include scroll-section();
:deep(.scroll-container) {
  padding: 0 20px;
}
</style>
